import { render } from "./announcement-bar.vue?vue&type=template&id=3daac686"
import script from "./announcement-bar.vue?vue&type=script&lang=js"
export * from "./announcement-bar.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__